import { Module } from 'vuex'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { BooksState } from './types'
import { RootState } from '../types'

export const state: BooksState = {
  searchKeyword: '',
  bestBook: null,
  conditions: [],
  activeGuidePrice: null,
  requestSearchBook: false,
  requestGetConditions: false,
  requestGetGuidePrices: false,
  error: null,
}

const namespaced: boolean = true

export const books: Module<BooksState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
}
